import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Image as ImageIcon } from "lucide-react";

import { PageHeader } from "@/shared/ui/PageHeader";
import { RecentWorksRow } from "@/entities/work/ui/RecentWorksRow";
import { DEPT_TITLE_KEY } from "@/entities/work/model/deptTitles";
import { ImagePreviewLightbox } from "./components/ImagePreviewLightbox";
import { PosterHubSections } from "./components/home/PosterHubSections";

/**
 * 创意设计中心 —— **纯卡墙**(2026-07-24 IA 二次收口 F1-b)。
 *
 * ═══ 这一页从 730 行收到这里,搬走了什么 ═══════════════════════════════════════
 * 「进行中 / 草稿 / 历史(状态 chips + 场景 chips + 搜索 + 真分页 + 批量打包下载 + 已排程)」
 * 整体搬进 `/works` —— 那是**检索**,与卡墙的**选择**是两种意图。730 行里 13 处在干这件事。
 *
 * ★一条能力都没丢,逐条对得上:
 *   收藏 / 内联重命名 / 删除 / 重试 / 草稿恢复 / 在途 5s 轮询 → `/works` 的作品卡与三节
 *   批量打包下载(海报独有,后端只有海报有 zip 端点)→ `/works` 选定海报线后出现
 *   已排程(定时出图)→ `/works` 顶部(它是「要跑的」,和在途同族,不是「能做什么」)
 *
 * 保留 `ImagePreviewLightbox`:「列表=预览,详情=编辑」是这个仓既定的分工,最近作品带
 * 点图仍先开轻量灯箱,不直接跳进详情编辑页。
 */
export default function PosterDashboardPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [lightboxTaskId, setLightboxTaskId] = useState<number | null>(null);
  const [lightboxCover, setLightboxCover] = useState<string | null>(null);

  return (
    <>
      <div className="w-full space-y-6">
        {/*
         * ★页头不再挂动作按钮(V1 §4.1)。原来那三个(从爆款 / 自由创作 / 从模板)把两种
         * 不同的东西摆成一排:前后两个是**来源**、中间那个是**兜底**,而且主按钮的视觉
         * 权重压过整面卡墙 —— 用户第一眼看到「自由创作」,而不是「我要干什么」。
         * 现在:来源 → 卡墙顶部的来源入口条;兜底 → 卡墙末尾的「我自己描述」卡。
         */}
        <PageHeader
          icon={ImageIcon}
          title={t(DEPT_TITLE_KEY.poster)}
          subtitle="先想清楚这张图拿去干什么,再选出成什么样 —— 只有图块 AI 出图,文字 / 参数 / 报表取你的真数据模板渲染。"
        />

        {/* 来源入口条 + 目的卡墙 5 组 + 兜底卡 */}
        <PosterHubSections />

        <RecentWorksRow
          lines={["poster"]}
          onOpen={(w) => {
            // 带上已加载的缩图当占位:灯箱拉原图期间先显缩图,不闪白框
            setLightboxCover(w.coverUrl);
            setLightboxTaskId(w.id);
          }}
          onViewAll={(href) => navigate(href)}
        />
      </div>

      <ImagePreviewLightbox
        taskId={lightboxTaskId}
        coverUrl={lightboxCover}
        onClose={() => setLightboxTaskId(null)}
        onEnterDetail={(id) => navigate(`/ai-haibao/tasks/${id}`)}
      />
    </>
  );
}
